import http from '@monolith/legacy/services/api/http';
import { captureException } from '@core/plugins/sentry';

const JSON_API_HEADERS = {
  'Content-Type': 'application/vnd.api+json',
  Accept: 'application/vnd.api+json',
};

interface EmailVerificationAttributes {
  email: string;
  expiresInMinutes?: number;
  verifiedAt?: string | null;
}

export interface EmailVerificationResponse {
  data: {
    type: 'email-verifications';
    id: string; // verification token
    attributes: EmailVerificationAttributes;
  };
}

export const sendVerificationCode = async (email: string): Promise<EmailVerificationResponse> => {
  return http()
    .post(
      '/api/v1/email-verifications',
      {
        data: {
          type: 'email-verifications',
          attributes: { email },
        },
      },
      { headers: JSON_API_HEADERS }
    )
    .then((response) => response.data)
    .catch((error) => {
      captureException(new Error(`Failed to send verification code: ${error}`));
      throw error;
    });
};

export const verifyCode = async (token: string, code: string): Promise<EmailVerificationResponse> => {
  return http()
    .patch(
      `/api/v1/email-verifications/${token}`,
      {
        data: {
          type: 'email-verifications',
          id: token,
          attributes: { code },
        },
      },
      { headers: JSON_API_HEADERS }
    )
    .then((response) => response.data)
    .catch((error) => {
      captureException(new Error(`Invalid verification code: ${error}`));
      throw error;
    });
};

// Resend uses the same endpoint as send
export const resendVerificationCode = sendVerificationCode;
